import React, { useEffect, useState } from 'react';

import './styles.css';

import close from '../../../assets/images/close.svg';
import statistics from '../../../assets/images/statistics.svg';
import user5 from '../../../assets/images/user5.svg';
import pin4 from '../../../assets/images/pin4.svg';
import calendar2 from '../../../assets/images/calendar2.svg';
import moment from "moment";
import 'moment/locale/pt-br';
import api from '../../../services/api';

export const ModalCustomersServed = ({ handleClose, title, id, type, totalAtendimentos, filter, plantoesName, date }) => {
  const [atendimentos, setAtendimentos] = useState([]);

  useEffect(() => {
    getAtendimentos();
  }, []);
  const getAtendimentos = async () => {
    const { data } = await api.get(`${type}/${id}/atendimentos`, {
      params: filter
    });
    setAtendimentos(data.atendimentos);
  }


  return (
    <div className="dash-modal">
      <div className="dash-modal-content lg">
        <button className="btn-close" onClick={() => handleClose()}><img src={close} /></button>
        <div className="dash-modal-header header-modal-pages">
          <div>
            <img src={statistics} />
            <h1>Estatísticas</h1>
          </div>
          <div className="data-about">
            <img src={user5} />
            <h1>{totalAtendimentos}</h1>
            <p>{title}</p>
          </div>
        </div>
        <div className="box-modal-gray">
          <div className="box-gray-modals">
            <img src={pin4} />
            <p>{plantoesName}</p>
          </div>
          <div className="box-gray-modals">
            <img src={calendar2} />
            <p>{date}</p>
          </div>
        </div>
        <div className="dash-modal-body">
          <div className="box-card h-full">
            <div className="box-card-noPadding box-table-shifts">
              <table className="table-dash">
                <thead>
                  <tr className="light-blue">
                    <th>Dia</th>
                    <th>Plantão</th>
                    <th>Esp.</th>
                    <th>Ind.</th>
                    <th>Ret.</th>
                    <th>Lig.</th>
                    <th>Total</th>
                    {/* <th>{type === "gerentes" ? "Atendimentos do time" : "Atendimentos"}</th> */}
                  </tr>
                </thead>
                <tbody>
                  {atendimentos.map((atendimento, key) => (
                    <tr key={key}>
                      <td>{moment(atendimento.data).format("DD/MM/YYYY")}</td>
                      <td>{atendimento.plantao.imovel_nome}</td>
                      <td>{atendimento.atendimentos_espontaneo}</td>
                      <td>{atendimento.atendimentos_indicacao}</td>
                      <td>{atendimento.atendimentos_retorno}</td>
                      <td>{atendimento.atendimentos_ligacao}</td>
                      <td>{atendimento.atendimentos}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="dash-modal-footer">

        </div>
      </div>
    </div>
  );

}

export default ModalCustomersServed;